export const QOS_STATS_INTERVAL = 3_000;
